import { getAPI } from "../../../api/Networking";
import { APIResponse } from "../../../models/NetworkResponse";
import {
  CampaignEligibleEmployeesParams,
  CampaignListingParams,
  CampaignTodayShipmentsParams,
} from "../../../models/Campaigns/Campaign";

export default class CampaignAPI {
  private buildCampaignQuery = (params: Record<string, unknown>) => {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, String(value));
      }
    });
    return queryParams.toString();
  };

  getCampaignListing = async (
    params: CampaignListingParams,
  ): Promise<APIResponse> => {
    const query = this.buildCampaignQuery({
      page_no: params.page_no,
      limit: params.limit,
      search: params.search?.trim() || undefined,
      campaign_id:
        params.campaign_id && params.campaign_id > 0
          ? params.campaign_id
          : undefined,
      customer_id:
        params.customer_id && params.customer_id > 0
          ? params.customer_id
          : undefined,
      status: params.status,
    });
    return getAPI(`/v5/admin/campaigns?${query}`);
  };

  getCampaignEligibleEmployees = async (
    campaignId: number,
    params: CampaignEligibleEmployeesParams,
  ): Promise<APIResponse> => {
    const query = this.buildCampaignQuery({
      date_utc: params.date_utc,
      search: params.search?.trim() || undefined,
    });
    return getAPI(`/v5/admin/campaigns/${campaignId}/eligible-employees?${query}`);
  };

  getCampaignTodayShipments = async (
    campaignId: number,
    params: CampaignTodayShipmentsParams,
  ): Promise<APIResponse> => {
    const query = this.buildCampaignQuery({
      date_utc: params.date_utc,
      page_no: params.page_no,
      limit: params.limit,
      status: params.status,
      sort_by: params.sort_by,
      sort_type: params.sort_type,
      search_text: params.search?.trim() || undefined,
    });
    return getAPI(`/v5/admin/campaigns/${campaignId}/today-shipments?${query}`);
  };
}
